import React, { useState } from 'react';
import { useTable, useFilters, useGlobalFilter, usePagination, useSortBy } from 'react-table';
import Input from '../input/Input';
import style from './table.module.css'

function Table({ columns, data, showPageDataCount = null, searchFilter = null }) {
    const [values, setValues] = useState(1)
    const [currentPage, setCurrentPage] = useState(1);
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        state,
        setGlobalFilter,
        gotoPage,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        pageCount,
        setPageSize,
    } = useTable(
        { columns, data, initialState: { pageIndex: 0, pageSize: showPageDataCount != null ? showPageDataCount : 5 } },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination,
    );

    const { globalFilter, pageIndex, pageSize } = state;

    return (
        <>
          { searchFilter == true ? <div className={style.section}>
                <div className="grid columns-12 gap-4 gap-y-5 mt-3 pt-5">
                    <select
                        value={pageSize}
                        className='intro-y g-col-5 g-col-md-3 g-col-xl-3 px-8 '
                        onChange={e => {
                            setPageSize(Number(e.target.value));
                        }}
                    >
                        {[5, 10, 20, 25, 50].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                            </option>
                        ))}
                    </select>
                    <Input
                        type="search"
                        id="claimSearch"
                        label="search..."
                        name="claimSearch"
                        value={globalFilter || ''}
                        onChange={e => setGlobalFilter(e.target.value)}
                        maxLength="100"
                    />
                </div>
            </div> : null}
            <table {...getTableProps()} className={style.table} >
                <thead>
                    {headerGroups.map(headerGroup => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map(column => (
                                <th
                                     title={''}
                                    {...column.getHeaderProps()}
                                    {...column.getHeaderProps(column.getSortByToggleProps({ title: undefined }))}
                                    className={style.table_header}
                                >
                                    {column.render('Header')}
                                    <span>
                                        {column.isSorted ? (column.isSortedDesc ? ' 🔽' : ' 🔼') : ''}
                                    </span>
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {page.map(row => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()} style={{ borderBottom: 'solid 1px black', }}>
                                {row.cells.map(cell => {
                                    return (
                                        <td
                                            {...cell.getCellProps()}
                                            className={style.table_body}
                                        >
                                            {cell.column.id == 'status' ? (
                                                <span className={`py-1 px-5 g-col-5 rounded-pill fs-xs ${cell.value == 'Denied' ? `bg-theme-6` : cell.value == 'Pending' ? `bg-yellow` : (cell.value == 'Approved' || cell.value == 'Paid') ? `bg-theme-9` : `bg-default`} text-white cursor-pointer fw-medium text-center`}>
                                                    {cell.render('Cell')}
                                                </span>
                                            ) : (
                                                cell.render('Cell')
                                            )}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className={style.section}>
                <button className='buttons_style btn me-3' onClick={() => {
                    setCurrentPage(Number(currentPage) - 1)
                    setValues(Number(currentPage) - 1);
                    previousPage()
                }} disabled={!canPreviousPage}>
                    {'Previous'}
                </button>{' '}
                <span>
                    Page{' '}
                    <input
                        type="number"
                        value={values}
                        onChange={e => {
                            const page = e.target.value ? Number(e.target.value) - 1 : 0;
                            if (page >= 0 && page < pageCount) {
                                setValues(e.target.value)
                                setCurrentPage(e.target.value != "" ? e.target.value : currentPage)
                                gotoPage(page);
                            } else {
                                gotoPage(Number(pageCount) - 1);
                                setValues(Number(pageCount))
                            }

                        }}
                        style={
                            {
                            width: "60px",
                            padding: "10px",
                            border: "1px solid #9c9999",
                            borderRadius: "3px"
                           }
                         }
                    />{' '}
                    of {pageOptions.length}
                </span>{' '}
                <button className='verifyAddres btn pe-2' onClick={() => {
                    setCurrentPage(Number(currentPage) + 1)
                    setValues(Number(currentPage) + 1);
                    nextPage()
                }} disabled={!canNextPage}>
                    {'Next'}
                </button>{' '}
            </div>
        </>
    );
}

export default Table;
